import { FC, memo, MouseEvent } from 'react';

import { SelectSearchList } from '/shared/SelectSearchList';

import { ITagsSelectProps } from './types';
import { useSortEntityWithCount } from './hooks';
import { SearchCustomInput, SortOptions, ViewSelect } from './components';

export const TagsSelect: FC<ITagsSelectProps> = memo(
  ({ onSelect, tag, mainColor, selected, addCustomValue = true, isSelectable = false }) => {
    const { searchOptions, hasValues, typeSort, handleChange, changeDirectionSort } = useSortEntityWithCount({
      entityWithCount: tag,
    });

    return (
      <SelectSearchList
        label=''
        SearchRender={
          addCustomValue
            ? ({ closeAnchorEl, ...props }) => {
                const submitValue = (val: string) => {
                  onSelect(tag.key, val);
                  closeAnchorEl();
                };
                return <SearchCustomInput {...props} submitValue={submitValue} />;
              }
            : undefined
        }
        ViewRender={({ viewSelectProps, openAnchorEl }) => {
          const canSelectDirectly = isSelectable || !hasValues;
          const hasOnlyDropdown = !isSelectable && hasValues;
          const handleSelect = (e: MouseEvent<HTMLButtonElement>) => {
            return canSelectDirectly ? onSelect(tag.key) : openAnchorEl(e);
          };
          return (
            <ViewSelect
              tagKey={tag.key}
              mainColor={mainColor}
              selected={selected}
              viewSelectProps={viewSelectProps}
              hasOnlyDropdown={hasOnlyDropdown}
              showDropdownWithSelect={canSelectDirectly}
              onClick={handleSelect}
              openAnchorEl={openAnchorEl}
            />
          );
        }}
        fullWidth
        onItemSelect={({ value }) => onSelect(tag.key, value)}
        itemList={searchOptions}
      >
        <SortOptions handleChange={handleChange} changeDirectionSort={changeDirectionSort} typeSort={typeSort} />
      </SelectSearchList>
    );
  }
);
